import { render, staticRenderFns } from "./CampaignStatistic.vue?vue&type=template&id=1b05797b&"
import script from "./CampaignStatistic.vue?vue&type=script&lang=js&"
export * from "./CampaignStatistic.vue?vue&type=script&lang=js&"
import style0 from "./CampaignStatistic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports